<template>
  <div class="payment-estimates">
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>

    <template v-else-if="estimates.length > 0">
      <estimates-table :estimates="estimates" :products="products" :estimation-complete="estimationComplete" @item-change="$emit('item-change', $event)" />

      <div v-if="loading" class="payment-estimates__loading-overlay"></div>
    </template>

    <img
      v-if="loading"
      src="/wp-content/themes/snappy-theme/assets/images/loading2.gif"
      class="payment-estimates__loading-spinner"
    />
  </div>
</template>

<script>
import EstimatesTable from './EstimatesTable';

export default {
  name: 'payment-estimates',
  components: {EstimatesTable},
  props: {
    error: {
      type: String,
    },
    estimates: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    products: {
      type: Array,
      required: true,
    },
    estimationComplete: {
      type: Boolean,
    }
  },
};
</script>

<style lang="scss" scoped>
.payment-estimates {
  min-height: 50px;
  position: relative;

  &__loading-overlay {
    background: rgba(#000000, 0.1);
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  &__loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    z-index: 1;
  }
}
</style>
